/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    RADIO MODULE
\*------------------------------------*/
class Radio {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        $(function() {
            var col, el;
            
            $("input[type=radio]").on("click", function() {
               el = $(this);
               col = el.data("col");
               $("input[data-col=" + col + "]").prop("checked", false);
               el.prop("checked", true);
            });
        });
    }
}

export default Radio;